import { render } from "./WorkSection.vue?vue&type=template&id=cd7bfb12&scoped=true"
import script from "./WorkSection.vue?vue&type=script&lang=js"
export * from "./WorkSection.vue?vue&type=script&lang=js"

import "./WorkSection.vue?vue&type=style&index=0&id=cd7bfb12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd7bfb12"]])

export default __exports__